import {
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    SET_LESSON_VIDEO_CURRENT_TIME,
    SET_LESSON_VIDEO_IS_PAUSED,
    SET_LESSON_TOTAL_PAGES,
    SET_LESSON_PAGE_NUMBER,
    SET_LESSON_PDF_LOADING_STATE,
    LOAD_LESSON_PDF,
    PREVIOUS_PDF_PAGE_IF_ABLE,
    NEXT_PDF_PAGE_IF_ABLE,
    A_AFTER_NAVIGATION_LESSON_MODULE,
} from '../services/constants'
import lodash from '../services/lodash'
import helpers from '../services/helpers'
import http from '../services/axios'
import pdf from '../services/pdf'

const lesson = {
    state: {
        sharedVideoState: {
            currentTime: 0,
            paused: true,
        },
        pdfInfo: {
            numPages: 0,
            pageNumber: 1,
            loadingState: LOADING_PRISTINE,
        },
    },
    mutations: {
        [SET_LESSON_VIDEO_CURRENT_TIME]: (state, payload) => {
            state.sharedVideoState.currentTime = payload
        },
        [SET_LESSON_VIDEO_IS_PAUSED]: (state, payload) => {
            state.sharedVideoState.paused = payload
        },
        [SET_LESSON_PDF_LOADING_STATE]: (state, payload) => {
            state.pdfInfo.loadingState = payload
        },
        [SET_LESSON_TOTAL_PAGES]: (state, payload) => {
            state.pdfInfo.numPages = payload
        },
        [SET_LESSON_PAGE_NUMBER]: (state, payload) => {
            state.pdfInfo.pageNumber = payload
        },
    },
    actions: {
        [LOAD_LESSON_PDF]: (context, payload) => {
            context.commit(SET_LESSON_PDF_LOADING_STATE, LOADING_STARTED)
            return pdf.createLoadingTask(payload).then(pdf => {
                context.commit(SET_LESSON_PDF_LOADING_STATE, LOADING_COMPLETED_SUCCESS)
                context.commit(SET_LESSON_TOTAL_PAGES, pdf.numPages)
            }).catch(err => {
                context.commit(SET_LESSON_PDF_LOADING_STATE, LOADING_COMPLETED_FAILURE)
                console.log(err)
            })
        },
        [PREVIOUS_PDF_PAGE_IF_ABLE]: (context) => {
            if (context.state.pdfInfo.pageNumber > 1) {
                context.commit(SET_LESSON_PAGE_NUMBER, context.state.pdfInfo.pageNumber - 1)
            }
        },
        [NEXT_PDF_PAGE_IF_ABLE]: (context) => {
            if (context.state.pdfInfo.pageNumber < context.state.pdfInfo.numPages) {
                context.commit(SET_LESSON_PAGE_NUMBER, context.state.pdfInfo.pageNumber + 1)
            }
        },
        [A_AFTER_NAVIGATION_LESSON_MODULE]: (context, toRoute) => {
            const actions = []
            const mutations = []
            mutations.push(context.commit(SET_LESSON_PAGE_NUMBER, 1))
            return Promise.all(actions.concat(mutations))
        },

    }
}

export default lesson
export {lesson}